var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2929 1.61321C11.6834 1.22268 12.3166 1.22268 12.7071 1.61321L16.7071 5.61321C17.0976 6.00373 17.0976 6.6369 16.7071 7.02742C16.3166 7.41794 15.6834 7.41794 15.2929 7.02742L13 4.73453L13 15.3203C13 15.8726 12.5523 16.3203 12 16.3203C11.4477 16.3203 11 15.8726 11 15.3203L11 4.73453L8.70711 7.02742C8.31658 7.41794 7.68342 7.41794 7.29289 7.02742C6.90237 6.6369 6.90237 6.00373 7.29289 5.61321L11.2929 1.61321Z",
    fill: "#1E1E1E",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.3203C4.55228 11.3203 5 11.768 5 12.3203V20.3203C5 20.5855 5.10536 20.8399 5.29289 21.0274C5.48043 21.215 5.73478 21.3203 6 21.3203H18C18.2652 21.3203 18.5196 21.215 18.7071 21.0274C18.8946 20.8399 19 20.5855 19 20.3203V12.3203C19 11.768 19.4477 11.3203 20 11.3203C20.5523 11.3203 21 11.768 21 12.3203V20.3203C21 21.116 20.6839 21.879 20.1213 22.4416C19.5587 23.0042 18.7957 23.3203 18 23.3203H6C5.20435 23.3203 4.44129 23.0042 3.87868 22.4416C3.31607 21.879 3 21.116 3 20.3203V12.3203C3 11.768 3.44772 11.3203 4 11.3203Z",
    fill: "#1E1E1E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.75272e658f1e5c2593671ccccce37cf0.svg";
export { ForwardRef as ReactComponent };